import React, { useRef, useEffect } from "react";
import logo from './logo.svg';
import instagram from './instagram.svg'
import arrow from './down-arrow.svg'
import logoPatternBlack from './logo-pattern-black.svg'
import logoPatternWhite from './logo-pattern-white.svg'
import './App.css';
import background from './background.mp4';
import {BrowserView, MobileView} from 'react-device-detect';

// Imagens do banner do Instagram (capas dos Reels)
import insta1 from './insta-reel1.jpeg';
import insta2 from './insta-reel2.jpeg';
import insta3 from './insta-reel3.jpeg';
import insta4 from './insta-reel4.jpeg';

const INSTAGRAM_URL = 'https://www.instagram.com/thebodylab.pt/';
const BOOKING_URL = 'https://thebodylab.buk.pt';
const WHATSAPP_NUMBER = '916808806';
const AVALIACAO_URL = '/avaliacao.html';

// Imagens do banner do Instagram
const instaPosts = [insta1, insta2, insta3, insta4];

// Desafios online — edita o título, descrição e preço de cada um.
// O botão abre o WhatsApp com uma mensagem já preenchida para pagamento por MB Way.
const challenges = [
  {
    title: 'Desafio 30 Dias Glúteos',
    description: 'Plano completo de 30 dias focado no fortalecimento e definição de glúteos. Treinos guiados e acompanhamento.',
    price: '30€',
  },
  {
    title: 'Desafio 28 Dias Mudança de Hábitos',
    description: 'Um método para criar rotinas de treino e alimentação adaptadas à tua realidade — longe dos mitos e das falsas promessas.',
    price: '28€',
  },
  {
    title: 'Desafio Express 14 Dias',
    description: 'Duas semanas intensas para arrancar com energia. Ideal para quem quer resultados rápidos.',
    price: '19€',
  },
];

function App() {
  const bookingRef = useRef(null);

  // Carrega o widget de reviews do Google (Elfsight) de forma fiável.
  // Se o script já existir, força a reinicialização para o widget renderizar.
  useEffect(() => {
    const SRC = 'https://elfsightcdn.com/platform.js';
    const existing = document.querySelector(`script[src="${SRC}"]`);
    if (existing) {
      // Script já presente — pede ao Elfsight para reprocessar a página
      if (window.eapps && typeof window.eapps.initWidgetsFromBuffer === 'function') {
        window.eapps.initWidgetsFromBuffer();
      }
    } else {
      const script = document.createElement('script');
      script.src = SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const goToBooking = () => {
    bookingRef.current?.scrollIntoView({ block: "nearest", behavior: 'smooth' });
  }

  // Abre o WhatsApp com uma mensagem pré-preenchida para pagamento via MB Way
  const buyChallenge = (challenge) => {
    const message = encodeURIComponent(
      `Olá! Tenho interesse no "${challenge.title}" (${challenge.price}). Gostaria de pagar por MB Way. Como procedo?`
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  }

  return (
    <>
    <div className="topbar">
      <a className="topbar-cta" href={AVALIACAO_URL} target="_blank" rel="noopener noreferrer">
        1ª Avaliação Física
      </a>
    </div>
    <div className="App">
      <div className="content">
        <div className='content-main'>
          <img src={logo} className="App-logo" alt="logo" />
          <p className="hero-tagline">Serviço de acompanhamento físico personalizado</p>
          <p className="hero-text">Atreve-te a sonhar com uma melhor versão tua. Temos uma equipa super experiente que trabalha de acordo com um método rigoroso para te dar os melhores resultados possíveis dentro daquilo que é a tua realidade.</p>
          <a className="hero-cta" href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">
            Envia mensagem e trata de tratar de ti
          </a>
        </div>
        <div className='Moreinfo'>
          <p className="moreinfotext">Mais informações</p>
          <div className="arrow">
            <img src={arrow} alt="moreinfo" onClick={goToBooking} />
          </div>
        </div>
      </div>
      <div className="video-overlay"/>
        <BrowserView>
          <div className="video-background">
            <div className="video-foreground">
              <video autoPlay loop muted>
                <source src={background} type="video/mp4" />
              </video>
            </div>
          </div>
        </BrowserView>
        <MobileView>
          <div className='img-background'></div>
        </MobileView>
    </div>

    {/* Banda dividida: Marcar Sessão | WhatsApp */}
    <div ref={bookingRef} className="booking-split">
      <a className="booking-half book" href={BOOKING_URL} target="_blank" rel="noopener noreferrer"
         style={{ backgroundImage: `url(${logoPatternBlack})` }}>
        <span className="booking-half-title">Marca a tua Sessão</span>
        <span className="booking-half-sub">Agenda já o teu treino</span>
      </a>
      <a className="booking-half contact" href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer"
         style={{ backgroundImage: `url(${logoPatternWhite})` }}>
        <span className="booking-half-title">Entrar em Contacto</span>
        <span className="booking-half-sub">Fala connosco no WhatsApp</span>
      </a>
    </div>

    {/* Banner do Instagram */}
    <div className="instagram-banner">
      <h2 className="section-title">O QUE SE PASSA NO NOSSO INSTAGRAM</h2>
      <p className="section-subtitle">Segue @thebodylab.pt para conteúdo, dicas e motivação.</p>
      <div className="instagram-grid">
        {instaPosts.map((img, i) => (
          <a
            key={i}
            className="instagram-item"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundImage: `url(${img})` }}
            aria-label="Ver no Instagram"
          >
            <div className="instagram-overlay">
              <img src={instagram} alt="instagram" />
            </div>
          </a>
        ))}
      </div>
      <a className="instagram-follow" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
        Seguir no Instagram
      </a>
    </div>

    {/* Desafios online */}
    <div className="challenges">
      <h2 className="section-title challenges-title">DESAFIOS ONLINE</h2>
      <p className="section-subtitle challenges-subtitle">Escolhe o teu desafio. Pagamento por MB Way via WhatsApp.</p>
      <div className="challenges-grid">
        {challenges.map((challenge, i) => (
          <div className="challenge-card" key={i}>
            <h3 className="challenge-name">{challenge.title}</h3>
            <p className="challenge-desc">{challenge.description}</p>
            <p className="challenge-price">{challenge.price}</p>
            <button className="challenge-button" onClick={() => buyChallenge(challenge)}>
              Atreve-te
            </button>
          </div>
        ))}
      </div>
    </div>

    {/* Reviews do Google (widget Elfsight) — última secção */}
    <div className="reviews">
      <h2 className="section-title reviews-title">O QUE DIZEM DE NÓS</h2>
      <div className="elfsight-app-1e1f36eb-2b8a-4bf4-b75d-4945c5c7bab8" data-elfsight-app-lazy></div>
    </div>

    <div className="footer">
      {/* <p>© 2023 The Body Lab . All Rights Reserved.</p> */}
    </div>
    </>
  );
}

export default App;
